import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const railbillingMethodsAdapter = getAdapter({ idFieldName: 'value' });

const railbillingMethodsSlice = createSlice({
  name: 'railbillingMethods',
  initialState: railbillingMethodsAdapter.getInitialState(),
  reducers: {
    setRailbillingMethods: (state, { payload: { railbillingMethods } }) => {
      railbillingMethodsAdapter.setAll(state, railbillingMethods);
    },
  },
});

const selectors = railbillingMethodsAdapter.getSelectors(({ railbillingMethods }) => railbillingMethods);

export const getRailbillingMethods = (state) => selectors.selectAll(state);

export const {
  setRailbillingMethods,
} = railbillingMethodsSlice.actions;

export default railbillingMethodsSlice.reducer;
